export default __webpack_public_path__ + "static/media/failed-tune.88b8217c.mp3";